<template>
  <div>
    <el-button class="filter-item" @click="handleReset"> 新增 </el-button>
    <grid-layout
      v-model:layout="layouts"
      :col-num="12"
      :row-height="30"
      :is-draggable="true"
      :is-resizable="true"
      :is-mirrored="false"
      :vertical-compact="true"
      :margin="[10, 10]"
      :use-css-transforms="false"
    >
      <grid-item v-for="item in layouts" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
        <div class="w100 h100 flex">
          <span class="flex-margin font14">{{ item.i }}</span>
        </div>
      </grid-item>
    </grid-layout>
  </div>
</template>
<script >
import { defineComponent, reactive, toRefs } from 'vue'
import { createMenu } from '@/apis/menu'
export default defineComponent({

  setup() {
    // watch(() => props.permissionName, (val) => {
    //   console.log(val)
    // })

    const tableData = reactive({
      layouts: [
        { x: 0, y: 0, w: 2, h: 2, i: '0' },
        { x: 2, y: 0, w: 2, h: 4, i: '1' },
        { x: 4, y: 0, w: 2, h: 5, i: '2' },
        { x: 6, y: 0, w: 2, h: 3, i: '3' },
        { x: 8, y: 0, w: 2, h: 3, i: '4' },
        { x: 10, y: 0, w: 2, h: 3, i: '5' },
        { x: 0, y: 5, w: 2, h: 5, i: '6' }
      ],
      handleReset() {
        // Object.keys(permissionName).forEach(element => {
        const element = 'OUTSOURCE_COMPANY_ACCOUNT'
          ;[{ key: 'LIST', name: '查看账户' }, { key: 'ADD', name: '新增账户' }, { key: 'EDIT', name: '编辑账户' }, { key: 'DELETE', name: '删除账户' }, { key: 'SET_DEFAULT', name: '设置默认账户' }].forEach((item, index) => {
          const temp = {
            superId: 152,
            type: 2,
            name: item.name,
            order: index + 9,
            icon: `${element}_${item.key}`,
            path: `${element}_${item.key}`,
            url: ''
          }
          //   if (index === 0) {
          createMenu(temp).then(res => {
            console.log(res)
          }).catch(err => {
            console.log(err)
          })
        //   }
        })
        // })

        // const temp = {
        //   superId: 1,
        //   type: 2,
        //   name: '编辑',
        //   order: 0,
        //   icon: 'aa',
        //   path: '',
        //   url: ''
        // }
        // create(temp).then((res: any) => {
        //   console.log(res)
        // })
      }

    })

    return { ...toRefs(tableData) }
  }
})

</script>
<style scoped lang="scss">

</style>
